import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../../dialog/dialog-config';

@Component({
    selector: 'kx-image-view',
    templateUrl: './image-view.component.html',
    styleUrls: ['./image-view.component.scss'],
    standalone: false
})
export class ImageViewComponent implements OnInit {
  imageData: any;

  constructor(
    private dialog: DialogConfig
  ) { }

  ngOnInit(): void {
    this.imageData = this.dialog.data
  }

}
